import React from 'react';
import { Helmet } from 'react-helmet';
import Button from '@omilia/button';

import {
  SIconImage,
  SErrorInfoContainer,
  SErrorH1,
  SErrorSubtitle,
  FixStyle,
} from 'components/styled';

import ErrorLayout from 'components/ErrorLayout';

const reloadPage = () => window.location.reload();

const GenericError = () => (
  <ErrorLayout>
    <Helmet>
      <title>Error</title>
    </Helmet>

    <SIconImage glyph="error-general" size="96" />

    <SErrorInfoContainer>
      <SErrorH1>Oops, error!</SErrorH1>
      <SErrorSubtitle level={1}>
        Sorry, it seems something went wrong!!
      </SErrorSubtitle>
    </SErrorInfoContainer>

    <FixStyle />
    <Button color="primary" variant="contained" onClick={reloadPage}>
      Reload Page
    </Button>
  </ErrorLayout>
);

export default GenericError;
